import { CartHelper } from "./CartHelper.js"
import { FormsHelper } from "./FormsHelper.js"
import { I18N } from "./I18N.js"
import { Spinner } from "./Spinner.js"
import { Toast } from "./Toast.js"
import { AddressHelper } from "./AddressHelper.js"
import { LebeledInput } from "./lib/LabeledInput.js"
import { Modal } from "./lib/Modal.js"
import { DateHelper } from "./lib/DateHelper.js"
import { OrderSchedule } from "./OrderSchedule.js"

export class Order {
	_target
	_visible
	_appContext
	_orderVO = {
		"orderId": CartHelper.getUuid(),
		"wantedLocalDateTime": null, //"2022-01-22T15:30:00", // TODO Use https://www.epochconverter.com/ with local time
		"storeId": null,
		"delivery": localStorage.getItem('delivery') === 'pickup' ? "pickup" : "delivery",
		"remarks": null,
		"cart": null,
		"fees": [],
		"discounts": [],
		"taxRates": [],
		"storeAddress": null,
		"storeContact": null,
		"contact": {
			/*"firstName": "Kai",
			"lastName": "Schäfer",
			"email": "kasch65@gmail.com",
			"phone": "0151 12345678"*/
		},
		"deliveryAddress": null /*{
			"street": "Brokstraße",
			"nr": "22",
			"doorbell": "Untere Klingel",
			"postalCode": "28203",
			"city": "Bremen",
			"country": "DE"
		}*/,
		"invoiceAddress": null /*{
			"street": "Brokstraße",
			"nr": "22b",
			"postalCode": "28203",
			"city": "Bremen",
			"country": "DE"
		}*/,
		"tour": null /*{
			"distance": 0.316,
			"distanceUnit": "km",
			"deliverySeconds": 79,
			"mode": "bicycling"
		}*/
	}
	_toastsToDismiss = []
	_onOrderUpdatedHandlers = []
	_onRequirePrepaidHandlers = []
	_storeOpening
	_deliveryOpening
	_scheduleOptions
	_maxSchedulePeriodHours = 48
	_scheduleSelectorToast
	_orderSchedule

	constructor(target) {
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
		this._target.innerHTML = `
			<h2 i18n>Order</h2>
			<fieldset>
				<legend i18n>Pickup or Delivery</legend>
				${LebeledInput.create('<label for="pickupRb" i18n>Pickup</label>', `<input type="radio" id="pickupRb" name="delivery" ${this._orderVO.delivery === 'pickup' ? 'checked' : ''}>`, true)}
				${LebeledInput.create('<label for="deliveryRb" i18n>Delivery</label>', `<input type="radio" id="deliveryRb" name="delivery" ${this._orderVO.delivery === 'delivery' ? 'checked' : ''}>`, true)}
				${LebeledInput.create('<label for="deliveryGpsRb" i18n>Delivery to GPS Position</label>', '<input type="radio" id="deliveryGpsRb" name="delivery" disabled>', true)}
			</fieldset>
			<fieldset id="orderTimeSelector"></fieldset>
			<h3 i18n>Store</h3>
			<fieldset id="storeContact" readonly>
				<legend i18n>Contact</legend>
				${LebeledInput.create('<label for="storeName" i18n>Name</label>', '<div id="storeName" class="output" readonly></div>', false)}
				${LebeledInput.create('<label for="storePhone" i18n>Phone</label>', '<div id="storePhone" class="output" readonly></div>', false)}
				${LebeledInput.create('<label for="storeEmail" i18n>E-Mail</label>', '<div id="storeEmail" class="output" readonly></div>', false)}
			</fieldset>
			<fieldset id="storeAddress" readonly>
				<legend i18n>Store Address</legend>
				${LebeledInput.create('<label for="storeStreet" i18n>Street</label>', '<div id="storeStreet" class="output" readonly></div>', false)}
				${LebeledInput.create('<label for="storeNr" i18n>Nr.</label>', '<div id="storeNr" class="output" readonly></div>', false)}
				<!--<div class="field-group">-->
					${LebeledInput.create('<label for="storePostalCode" i18n>Postal Code</label>', '<div id="storePostalCode" type="number" class="output" readonly></div>', false)}
					${LebeledInput.create('<label for="storeCity" i18n>City</label>', '<div id="storeCity" class="output" readonly></div>', false)}
				<!--</div>-->
				${LebeledInput.create('<label for="storeCountry" i18n>Country</label>', '<div id="storeCountry" class="output" readonly></div>', false, null, null, { hidden: null })}
			</fieldset>
			<div id="orderDliveryAddressForm" hidden>
				<fieldset id="deliveryAddress" disabled>
					<legend i18n>Delivery Address</legend>
					${LebeledInput.create('<label for="deliveryStreet" required i18n>Street</label>', '<input id="deliveryStreet" class="address-helper" required>', false)}
					${LebeledInput.create('<label for="deliveryNr" required i18n>Nr.</label>', '<input id="deliveryNr" class="address-helper" required>', false)}
					${LebeledInput.create('<label for="deliveryDoorbell" i18n>Doorbell</label>', '<input id="deliveryDoorbell">', false)}
					<!-- <div class="field-group"> -->
						${LebeledInput.create('<label for="deliveryPostalCode" required i18n>Postal Code</label>', '<input id="deliveryPostalCode" class="address-helper" type="number" required>', false)}
						${LebeledInput.create('<label for="deliveryCity" required i18n>City</label>', '<input id="deliveryCity" class="address-helper" required>', false)}
					<!-- </div> -->
					${LebeledInput.create('<label for="deliveryCountry" required i18n>Country</label>', '<input id="deliveryCountry" autocomplete="new-password" required readonly>', false, null, null, { hidden: null })}
					${LebeledInput.create('<label for="deliveryRemarks" i18n>Remarks</label>', '<input id="deliveryRemarks">', false)}
				</fieldset>
			</div>
			<div id="orderDliveryGeoPosForm" hidden>
				<h3 i18n>Delivery to GPS Position</h3>
				<div i18n>Requires advance payment</div>
				<fieldset id="deliveryGpsPos" disabled>
					${LebeledInput.create('<label for="deliveryGpsLat" i18n>Latitude</label>', '<input id="deliveryGpsLat">', false)}
					${LebeledInput.create('<label for="deliveryGpsLon" i18n>Longitude</label>', '<input id="deliveryGpsLon">', false)}
					<button id="deliveryPickCurrentPosBtn" class="primary" i18n>Pick current GPS Position</button>
					<button id="deliveryCheckCurrentPosBtn" i18n>Show on Map</button>
				</fieldset>
			</div>
			<h3 i18n>Remarks</h3>
			<textarea id="orderRemarks" rows="4" cols="40">${this._orderVO.remarks ? this._orderVO.remarks : ''}</textarea>
			<h3 i18n>Costs</h3>
			<div id="orderCosts"></div>
		`

		document.getElementById('pickupRb').addEventListener('change', ev => {
			if (ev.target.checked) {
				this._setDelivery('pickup')
				localStorage.setItem('delivery', 'pickup')
			}
		})
		document.getElementById('deliveryRb').addEventListener('change', ev => {
			if (ev.target.checked) {
				this._setDelivery('delivery')
				localStorage.setItem('delivery', 'delivery')
			}
		})
		document.getElementById('deliveryGpsRb').addEventListener('change', ev => {
			if (ev.target.checked) {
				this._setDelivery('deliveryGps')
				localStorage.setItem('delivery', 'deliveryGps')
			}
		})

		document.getElementById('deliveryPickCurrentPosBtn').addEventListener('click', ev => {
			this._onPickGpsPos()
		})
		document.getElementById('deliveryCheckCurrentPosBtn').addEventListener('click', ev => {
			const deliveryLat = document.getElementById('deliveryGpsLat').value
			const deliveryLon = document.getElementById('deliveryGpsLon').value
			if (deliveryLat && deliveryLon) {
				if (this._orderVO.storeAddress && this._orderVO.storeAddress.geoPos) {
					window.open(`https://www.openstreetmap.org/directions?engine=fossgis_osrm_bike&route=${deliveryLat}%2C${deliveryLon}%3B${this._orderVO.storeAddress.geoPos.lat},${this._orderVO.storeAddress.geoPos.lon}`)
				}
				else {
					window.open(`https://www.openstreetmap.org/#map=19/${deliveryLat}/${deliveryLon}`)
				}
			}
			else {
				const dialog = new Modal()
				dialog.setContentInnerHTML(I18N.translate('Please pick or enter GEO coordinates in decimal format!'))
				dialog.setButtonGroupInnerHTML('<button class="primary">OK</button>')
				dialog.setBtnClickHandler(0, () => { })
			}
		})
		// Remarks textarea
		const remarksTextarea = document.getElementById('orderRemarks')
		remarksTextarea.addEventListener('blur', () => {
			this._orderVO.remarks = remarksTextarea.value
		})
		// Update delivery address in orderVO when inputs are complete
		document.getElementById('deliveryNr').addEventListener('change', ev => {
			setTimeout(() => {
				this._processUpdatedDeliveryAddress()
			}, 1)
		})
		// Add the AddressHelper
		const addressHelper = new AddressHelper()
		addressHelper.addAddressHelper(document.getElementById('deliveryPostalCode'), document.getElementById('deliveryCity'), document.getElementById('deliveryStreet'), document.getElementById('deliveryNr'), () => {
			this._processUpdatedDeliveryAddress()
		})

		this._orderSchedule = new OrderSchedule('orderTimeSelector')

		I18N.translateElement(this._target)
	}

	_setDelivery = delivery => {
		if (delivery === 'pickup') {
			this._orderVO.delivery = 'pickup'
			this._toastsToDismiss.forEach(t => t.dismiss())
			this._toastsToDismiss = []
			document.getElementById('deliveryAddress').setAttribute('disabled', '')
			document.getElementById('deliveryGpsPos').setAttribute('disabled', '')
			document.getElementById('orderDliveryAddressForm').setAttribute('hidden', '')
			document.getElementById('orderDliveryGeoPosForm').setAttribute('hidden', '')
			this._updateFeesAndDiscounts()
			this._onRequirePrepaidHandlers.forEach(handler => handler(false))
		}
		else if (delivery === 'delivery') {
			this._orderVO.delivery = 'delivery'
			this._toastsToDismiss.forEach(t => t.dismiss())
			this._toastsToDismiss = []
			if (this._orderVO.deliveryAddress && this._orderVO.deliveryAddress.geoPos) {
				delete this._orderVO.deliveryAddress.geoPos
			}
			document.getElementById('deliveryGpsPos').setAttribute('disabled', '')
			document.getElementById('deliveryAddress').removeAttribute('disabled')
			document.getElementById('orderDliveryAddressForm').removeAttribute('hidden')
			document.getElementById('orderDliveryGeoPosForm').setAttribute('hidden', '')
			// Get session values to fill form
			FormsHelper.setAndRememberInputValue('deliveryStreet', null)
			FormsHelper.setAndRememberInputValue('deliveryNr', null)
			FormsHelper.setAndRememberInputValue('deliveryPostalCode', null)
			FormsHelper.setAndRememberInputValue('deliveryCity', null, 'Bremen')
			FormsHelper.setAndRememberInputValue('deliveryDoorbell', null)
			document.getElementById('deliveryDoorbell').addEventListener('change', ev => {
				FormsHelper.setAndRememberInputValue('deliveryDoorbell', ev.target.value)
			})
			FormsHelper.setAndRememberInputValue('deliveryCountry', null, 'DE')
			FormsHelper.setAndRememberInputValue('deliveryRemarks', null)
			document.getElementById('deliveryRemarks').addEventListener('change', ev => {
				FormsHelper.setAndRememberInputValue('deliveryRemarks', ev.target.value)
			})
			// Validate address if required fields are filled to get the green borders
			if (document.getElementById('deliveryStreet').value
				&& document.getElementById('deliveryNr').value
				&& document.getElementById('deliveryPostalCode').value
				&& document.getElementById('deliveryCity').value) {
				this._processUpdatedDeliveryAddress()
			}
			this._updateFeesAndDiscounts()
			this._onRequirePrepaidHandlers.forEach(handler => handler(false))
		}
		else if (delivery === 'deliveryGps') {
			this._orderVO.delivery = 'delivery'
			this._toastsToDismiss.forEach(t => t.dismiss())
			this._toastsToDismiss = []
			let deliveryAddress = this._orderVO.deliveryAddress
			if (!deliveryAddress) {
				deliveryAddress = {}
				this._orderVO.deliveryAddress = deliveryAddress
			}
			if (document.getElementById('deliveryGpsLat').value && document.getElementById('deliveryGpsLon').value) {
				deliveryAddress.geoPos = { lat: document.getElementById('deliveryGpsLat').value, lon: document.getElementById('deliveryGpsLon').value }
			}
			document.getElementById('deliveryAddress').setAttribute('disabled', '')
			document.getElementById('deliveryGpsPos').removeAttribute('disabled')
			document.getElementById('orderDliveryAddressForm').setAttribute('hidden', '')
			document.getElementById('orderDliveryGeoPosForm').removeAttribute('hidden')
			this._updateFeesAndDiscounts()
			this._onRequirePrepaidHandlers.forEach(handler => handler(true))
		}
	}

	addOnOrderUpdatedHandlers = (...onOrderUpdatedHandlers) => this._onOrderUpdatedHandlers.push(...onOrderUpdatedHandlers)

	addOnRequirePrepaidHandlers = (...onRequirePrepaidHandlers) => this._onRequirePrepaidHandlers.push(...onRequirePrepaidHandlers)

	setAppContext = appContext => this._appContext = appContext

	setVisible = visible => {
		if (this._visible === visible) {
			return
		}
		this._visible = Boolean(visible)
		if (visible) {
			this._target.removeAttribute('hidden')
			if (localStorage.getItem('delivery') === 'pickup') {
				this._setDelivery('pickup')
				document.getElementById('deliveryRb').removeAttribute('checked')
				document.getElementById('deliveryGpsRb').removeAttribute('checked')
				document.getElementById('pickupRb').setAttribute('checked', '')
			}
			else if (localStorage.getItem('delivery') === 'delivery') {
				this._setDelivery('delivery')
				document.getElementById('pickupRb').removeAttribute('checked')
				document.getElementById('deliveryGpsRb').removeAttribute('checked')
				document.getElementById('deliveryRb').setAttribute('checked', '')
			}
			else if (localStorage.getItem('delivery') === 'deliveryGps') {
				this._setDelivery('deliveryGps')
				document.getElementById('pickupRb').removeAttribute('checked')
				document.getElementById('deliveryRb').removeAttribute('checked')
				document.getElementById('deliveryGpsRb').setAttribute('checked', '')
			}
			this._orderSchedule.setDeliveryType(localStorage.getItem('delivery'))

			if (this._orderVO.discounts.some(f => f.type === 'PICKUP')) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translate('Pickup discount calculated'), Toast.INFO, 10))
			}


			this._orderSchedule.setSchedule(this._getLocalStorageSchedule())
			this._orderSchedule.addOnSetOrderScheduleHandlers(schedule => {
				this._orderVO.wantedLocalDateTime = schedule ? DateHelper.getIsoFormatOfDateTime(schedule) : null
				this._setLocalStorageSchedule(schedule)
			})
			this._orderSchedule.init()
		}
		else {
			this._target.setAttribute('hidden', '')
			this._toastsToDismiss.forEach(t => t.dismiss())
			this._toastsToDismiss = []
		}
	}

	addItemVO = (itemVO, store, taxRate) => {
		if (!this._orderVO.taxRates.some(oldTaxRate => oldTaxRate.id === taxRate.id)) {
			this._orderVO.taxRates.push(taxRate)
		}
	}

	setCartVO = cartVO => {
		this._orderVO.cart = cartVO
		if (this._orderVO.storeAddress) {
			this._updateStoreAddressForm(this._orderVO.storeAddress)
		}
		if (this._orderVO.cart && this._orderVO.cart.items && this._orderVO.cart.items.length) {
			this._orderVO.cart.net = CartHelper.calculateCartNet(this._orderVO.cart)
			this._orderVO.cart.tax = CartHelper.calculateCartTax(this._orderVO.cart)
			this._updateFeesAndDiscounts()
		}
		else {
			this._onOrderUpdatedHandlers.forEach(handler => handler(null))
			this._resetCosts()
		}
	}

	setStore = store => {
		if (!this._orderVO.storeId || this._orderVO.storeId !== store.id) {
			this._orderVO.storeId = store.id
			this._orderVO.storeAddress = store.address
			this._updateStoreAddressForm(store.address)
			this._orderVO.storeContact = store.contact
			this._updateStoreContactForm(store.contact)
			this._updateFeesAndDiscounts()
			// Check permission for GPS delivery target
			if (store.deliverer.accetpsGeoLocation) {
				document.getElementById('deliveryGpsRb').removeAttribute('disabled')
			}
			else {
				if (document.getElementById('deliveryGpsRb').checked) {
					document.getElementById('deliveryRb').checked = true
					this._setDelivery('delivery')
					new Toast('toaster', I18N.translate('This deliverer doesn\'t suppot delivery to GPS position!'), Toast.WARN, 10)
				}
				document.getElementById('deliveryGpsRb').setAttribute('disabled', '')
			}
			this._orderSchedule.setStores([store])
		}
	}

	_processUpdatedDeliveryAddress = () => {
		this._toastsToDismiss.forEach(t => t.dismiss())
		this._toastsToDismiss = []
		this._resetCosts()

		const deliveryStreetInput = document.getElementById('deliveryStreet')
		const deliveryNrInput = document.getElementById('deliveryNr')
		const deliveryPostalCodeInput = document.getElementById('deliveryPostalCode')
		const deliveryCityInput = document.getElementById('deliveryCity')
		const deliveryCountryInput = document.getElementById('deliveryCountry')
		// Remove Markers
		this._setFieldValidity(deliveryStreetInput, null)
		this._setFieldValidity(deliveryNrInput, null)
		this._setFieldValidity(deliveryPostalCodeInput, null)
		this._setFieldValidity(deliveryCityInput, null)
		this._setFieldValidity(deliveryCountryInput, null)
		const completeAddress = this._getCompleteAddress(
			deliveryStreetInput,
			deliveryNrInput,
			document.getElementById('deliveryDoorbell'),
			deliveryPostalCodeInput,
			deliveryCityInput,
			deliveryCountryInput,
			document.getElementById('deliveryRemarks'))
		// Validate changed address
		if (completeAddress) {
			console.log('Delivery address is now: ', completeAddress)
			this._validateAddress(completeAddress)
				.then(validatedAddress => {
					if (validatedAddress) {
						console.log('Delivery address verified!')
						// Update address VO
						completeAddress.street = validatedAddress.street.name
						completeAddress.postalCode = validatedAddress.zip.zip
						completeAddress.city = validatedAddress.city.name
						// Remember valid address in form fields
						FormsHelper.setAndRememberInputValue('deliveryStreet', validatedAddress.street.name)
						FormsHelper.setAndRememberInputValue('deliveryNr', completeAddress.nr)
						FormsHelper.setAndRememberInputValue('deliveryDoorbell', completeAddress.doorbell)
						FormsHelper.setAndRememberInputValue('deliveryPostalCode', validatedAddress.zip.zip)
						FormsHelper.setAndRememberInputValue('deliveryCity', validatedAddress.city.name)
						FormsHelper.setAndRememberInputValue('deliveryCountry', completeAddress.country)
						FormsHelper.setAndRememberInputValue('deliveryRemarks', completeAddress.remarks)
						// Mark validated fields
						this._setFieldValidity(deliveryStreetInput, 'valid')
						this._setFieldValidity(deliveryNrInput, 'valid')
						this._setFieldValidity(deliveryPostalCodeInput, 'valid')
						this._setFieldValidity(deliveryCityInput, 'valid')
						this._setFieldValidity(deliveryCountryInput, 'valid')
						// Update order with new address
						this._orderVO.deliveryAddress = completeAddress
						if (!this._orderVO.invoiceAddress) {
							this._orderVO.invoiceAddress = completeAddress
						}
						this._updateFeesAndDiscounts()
					}
					else {
						console.log('Address is invalid!')
						this._toastsToDismiss.push(new Toast('toaster', I18N.translate('The delivery address was not found on the city map and must be corrected!'), Toast.WARN))
						this._setFieldValidity(deliveryStreetInput, 'invalid')
						this._setFieldValidity(deliveryPostalCodeInput, 'invalid')
						this._setFieldValidity(deliveryCityInput, 'invalid')
					}
				})
		}
		else {
			if (this._markInvalidInput(deliveryStreetInput)) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translateAndFormat('{0} missing!', deliveryStreetInput.labels[0].innerText), Toast.WARN, 15))
			}
			if (this._markInvalidInput(deliveryNrInput)) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translateAndFormat('{0} missing!', deliveryNrInput.labels[0].innerText), Toast.WARN, 15))
			}
			if (this._markInvalidInput(deliveryPostalCodeInput)) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translateAndFormat('{0} missing!', deliveryPostalCodeInput.labels[0].innerText), Toast.WARN, 15))
			}
			if (this._markInvalidInput(deliveryCityInput)) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translateAndFormat('{0} missing!', deliveryCityInput.labels[0].innerText), Toast.WARN, 15))
			}
			if (this._markInvalidInput(deliveryCountryInput)) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translateAndFormat('{0} missing!', deliveryCountryInput.labels[0].innerText), Toast.WARN, 15))
			}
		}
	}

	_displayCosts = () => {
		const getFeeRows = () => this._orderVO.fees.map(f => `<tr>
				<td>${I18N.translate(f.type)}</td>
				<td class="priceColumn">${CartHelper.formatPrice(f.netFee)}</td>
				<td class="priceColumn">${CartHelper.formatPrice(f.tax)}</td>
				<td class="priceColumn">${CartHelper.formatPrice(f.netFee + f.tax)}</td>
			</tr>`).join('')

		const getDiscountRows = () => this._orderVO.discounts.map(d => `<tr>
				<td>${I18N.translate(d.type)}</td>
				<td class="priceColumn">${CartHelper.formatPrice(-d.netDiscount)}</td>
				<td class="priceColumn">${CartHelper.formatPrice(-d.tax)}</td>
				<td class="priceColumn">${CartHelper.formatPrice(-(d.netDiscount + d.tax))}</td>
			</tr>`).join('')

		if (this._orderVO.cart && this._orderVO.cart.items && this._orderVO.cart.items.length) {
			const table = `<table class="priceTable">
				<thead>
					<td></td>
					<td class="priceColumn" i18n>Net</td>
					<td class="priceColumn" i18n>Tax</td>
					<td class="priceColumn" i18n>Gross</td>
				</thead>
				<tbody>
					<tr>
						<td i18n>Items Value</td>
						<td class="priceColumn">${CartHelper.formatPrice(this._orderVO.cart.net)}</td>
						<td class="priceColumn">${CartHelper.formatPrice(this._orderVO.cart.tax)}</td>
						<td class="priceColumn">${CartHelper.formatPrice(this._orderVO.cart.net + this._orderVO.cart.tax)}</td>
					</tr>
					${getDiscountRows()}
					${getFeeRows()}
					<tr class="sumRow">
						<td i18n>You have to pay</td>
						<td class="priceColumn">${CartHelper.formatPrice(this._orderVO.net)}</td>
						<td class="priceColumn">${CartHelper.formatPrice(this._orderVO.tax)}</td>
						<td class="priceColumn">${CartHelper.formatPrice(this._orderVO.net + this._orderVO.tax)}</td>
					</tr>
				</tbody>
			</table>`
			document.getElementById('orderCosts').innerHTML = table
			this._onOrderUpdatedHandlers.forEach(handler => handler(this._orderVO))
			I18N.translateElement(document.getElementById('orderCosts'))
		}
		else {
			document.getElementById('orderCosts').innerHTML = ''
			this._onOrderUpdatedHandlers.forEach(handler => handler(this._orderVO))
		}
	}

	_resetCosts = () => {
		document.getElementById('orderCosts').innerHTML = ''
		this._onOrderUpdatedHandlers.forEach(handler => handler(null))
	}

	_updateStoreContactForm = contact => {
		document.getElementById('storeName').innerHTML = contact.company
		document.getElementById('storeEmail').innerHTML = contact.email
		document.getElementById('storePhone').innerHTML = contact.phone
	}

	_updateStoreAddressForm = storeAddress => {
		document.getElementById('storeStreet').innerHTML = storeAddress.street
		document.getElementById('storeNr').innerHTML = storeAddress.nr
		document.getElementById('storePostalCode').innerHTML = storeAddress.postalCode
		document.getElementById('storeCity').innerHTML = storeAddress.city
		document.getElementById('storeCountry').innerHTML = storeAddress.country
	}

	_getCompleteAddress = (streetInput, numberInput, doorbellInput, postalCodeInput, cityInput, countryInput, remarksInput) => {
		if (streetInput.value && numberInput.value && postalCodeInput.value && cityInput.value && countryInput.value) {
			const address = {
				street: streetInput.value,
				nr: numberInput.value,
				postalCode: postalCodeInput.value,
				city: cityInput.value,
				country: countryInput.value
			}
			if (doorbellInput && doorbellInput.value) {
				address.doorbell = doorbellInput.value
			}
			if (remarksInput && remarksInput.value) {
				address.remarks = remarksInput.value
			}
			return address
		}
		else {
			return null
		}
	}

	/**
	 * Marks required inputs with no value with 'invalid' attribute
	 * @param {*} input 
	 * @returns true if marked as invalid
	 */
	_markInvalidInput = input => {
		if (input) {
			if (input.hasAttribute('required')) {
				if (input.value) {
					input.removeAttribute('invalid')
					return false
				}
				else {
					this._setFieldValidity(input, 'invalid')
					return true
				}
			}
			else {
				return false
			}
		}
		else {
			return false
		}
	}

	_markFilledInput = input => {
		if (input) {
			if (input.hasAttribute('required')) {
				if (input.value) {
					this._setFieldValidity(input, 'valid')
				}
			}
		}
	}

	/**
	 * 
	 * @param {*} input 
	 * @param {*} validity 'valid'|'invalid'|null
	 */
	_setFieldValidity = (input, validity) => {
		if ('valid' === validity) {
			input.removeAttribute('invalid')
			input.setAttribute('valid', '')
		}
		else if ('invalid' === validity) {
			input.removeAttribute('valid')
			input.setAttribute('invalid', '')
		}
		else {
			input.removeAttribute('invalid')
			input.removeAttribute('valid')
		}
	}

	_validateAddress = address => {
		const spinner = new Spinner(this._target, 15)
		return new Promise((resolve, reject) => {
			fetch('https://addressservice.fairweben.de/list', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					"zip": { "zip": address.postalCode },
					"city": { "name": address.city },
					"street": { "name": address.street }
				})
			})
				.then(response => response.json()
					.then(json => {
						spinner.dismiss()
						resolve(json.length === 1 ? json[0] : null)
					})
				)
				.catch(e => {
					spinner.dismiss()
					new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', e), Toast.ERROR)
					reject(e)
				})
		})
	}

	_updateFeesAndDiscounts = () => {
		this._resetCosts()
		if (this._orderVO.cart && this._orderVO.cart.items && this._orderVO.cart.items.length) {
			if (this._orderVO.delivery === 'delivery' && this._orderVO.cart && this._orderVO.storeAddress && this._orderVO.deliveryAddress) {
				if (!(this._orderVO.deliveryAddress.street && this._orderVO.deliveryAddress.nr && this._orderVO.deliveryAddress.postalCode && this._orderVO.deliveryAddress.city) && !(this._orderVO.deliveryAddress.geoPos && this._orderVO.deliveryAddress.geoPos.lat && this._orderVO.deliveryAddress.geoPos.lon)) {
					this._toastsToDismiss.push(new Toast('toaster', I18N.translate('Please enter your delivery location'), Toast.INFO, 10))
					return
				}
				const spinner = new Spinner(this._target, 15)
				fetch(`https://rest.viertel-lieferservice.de/orders/fees`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						storeAddress: this._orderVO.storeAddress,
						order: {
							type: "DELIVERY",
							netValue: this._orderVO.cart.net,
							tax: this._orderVO.cart.tax,
							currency: "EUR",
							deliveryAddress: this._orderVO.deliveryAddress,
							storeId: this._orderVO.storeId
						}
					})
				})
					.then(response => {
						if (response.ok) {
							response.json()
								.then(json => {
									this._orderVO.fees = json.fees
									this._orderVO.discounts = json.discounts
									this._orderVO.tour = json.tour
									this._orderVO.net = Math.round((this._orderVO.cart.net + json.fees.map(f => f.netFee).reduce((a, b) => a + b, 0) - json.discounts.map(f => f.netDiscount).reduce((a, b) => a + b, 0)) * 100) / 100
									this._orderVO.tax = Math.round((this._orderVO.cart.tax + json.fees.map(f => f.tax).reduce((a, b) => a + b, 0) - json.discounts.map(f => f.tax).reduce((a, b) => a + b, 0)) * 100) / 100
									this._displayCosts()
									spinner.dismiss()
									if (json.fees.some(f => f.type === 'MISSING_TO_MIN_VALUE')) {
										new Toast('toaster', I18N.translate('We charge a surcharge for delivery up to the minimum order value. You can choose a few more extras from the card without paying more.'), Toast.INFO, 15)
									}
									if (json.fees.some(f => f.type === 'FREE_DELIVERY')) {
										new Toast('toaster', I18N.translate('Delivery fee saved'), Toast.INFO, 10)
									}
								})
						}
						else if (response.status === 400) {
							spinner.dismiss()
							response.text()
								.then(text => {
									if (text && text.includes('OUT_OF_DELIVERY_AREA')) {
										this._toastsToDismiss.push(new Toast('toaster', I18N.translate('Your address is outside of our delivery radius of 3 km. Choose pickup, arrange a delivery by phone, or extend your order over €50 to get a delivery up to 5km.'), Toast.WARN))
										const deliveryStreetInput = document.getElementById('deliveryStreet')
										const deliveryNrInput = document.getElementById('deliveryNr')
										const deliveryPostalCodeInput = document.getElementById('deliveryPostalCode')
										const deliveryCityInput = document.getElementById('deliveryCity')
										this._setFieldValidity(deliveryStreetInput, 'invalid')
										this._setFieldValidity(deliveryNrInput, 'invalid')
										this._setFieldValidity(deliveryPostalCodeInput, 'invalid')
										this._setFieldValidity(deliveryCityInput, 'invalid')
									}
									else {
										new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', text), Toast.ERROR)
									}
								})
						}
					})
					.catch(e => {
						spinner.dismiss()
						new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', e), Toast.ERROR)
					})
			}
			else if (this._orderVO.delivery === 'pickup') {
				const spinner = new Spinner(this._target, 15)
				fetch(`https://rest.viertel-lieferservice.de/orders/fees?type=PICKUP&netValue=${this._orderVO.cart.net}&tax=${this._orderVO.cart.tax}&currency=EUR&storeId=${this._orderVO.storeId}`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				})
					.then(response => response.json()
						.then(json => {
							this._orderVO.fees = []
							this._orderVO.discounts = json.discounts
							this._orderVO.net = Math.round((this._orderVO.cart.net - json.discounts.map(f => f.netDiscount).reduce((a, b) => a + b, 0)) * 100) / 100
							this._orderVO.tax = Math.round((this._orderVO.cart.tax - json.discounts.map(f => f.tax).reduce((a, b) => a + b, 0)) * 100) / 100
							this._displayCosts()
							spinner.dismiss()
							if (json.discounts.some(f => f.type === 'PICKUP') && !this._target.hasAttribute('hidden')) {
								this._toastsToDismiss.push(new Toast('toaster', I18N.translate('Pickup discount calculated'), Toast.INFO, 10))
							}
						})
					)
					.catch(e => {
						spinner.dismiss()
						new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', e), Toast.ERROR)
					})
			}
		}
		else {
			this._orderVO.fees = []
			this._orderVO.discounts = []
		}
	}

	_onPickGpsPos = () => {
		const allowedGpsToleranceM = 50
		navigator.geolocation.getCurrentPosition(position => {
			console.log(position.coords.latitude, position.coords.longitude)
			if (Number(position.coords.accuracy) > allowedGpsToleranceM) {
				this._toastsToDismiss.push(new Toast('toaster', I18N.translateAndFormat('The browser gives the GPS position with an accuracy of {0}m.<br>That´s not good enough for our deliverer.<br>Turn on GPS or go to an open-air location, if you´re not in a building with an valid address.', Math.round(position.coords.accuracy)), Toast.WARN))
			}
			else {
				document.getElementById('deliveryGpsLat').value = position.coords.latitude
				document.getElementById('deliveryGpsLon').value = position.coords.longitude
				let deliveryAddress = this._orderVO.deliveryAddress
				if (!deliveryAddress) {
					deliveryAddress = {}
					this._orderVO.deliveryAddress = deliveryAddress
				}
				deliveryAddress.geoPos = {
					lat: position.coords.latitude,
					lon: position.coords.longitude
				}
				this._toastsToDismiss.forEach(t => t.dismiss())
				this._toastsToDismiss = []

				this._updateFeesAndDiscounts()
				// TODO Request payment in advance
			}
		})
	}

	_getLocalStorageSchedule = () => {
		if (localStorage.getItem('scheduled') !== 'true') {
			return null
		}
		else {
			const localStorageSchedule = localStorage.getItem('schedule')
			return new Date(localStorageSchedule)

		}
	}

	_setLocalStorageSchedule = scheduleDate => {
		if (!scheduleDate) {
			localStorage.setItem('scheduled', false)
			localStorage.removeItem('schedule')
		}
		else {
			localStorage.setItem('schedule', DateHelper.getIsoFormatOfDateTime(scheduleDate))
			localStorage.setItem('scheduled', true)
		}
	}

}